import { createContext } from "react";

export interface UserAuthContextValue {
  logout: (showAlert: boolean, onAfterLogout?: () => void) => void;
  logoutSideEffects: () => void;
}

export const UserAuthContext = createContext<UserAuthContextValue | null>(null);
